import { FC, ReactNode } from 'react';

import { Box, Stack, SxProps, Theme } from '@mui/material';

import { DetailsCardTitle, SectionCard } from '../styles';

interface AwbSectionProps {
  icon?: ReactNode;
  title: string;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

const AwbSection: FC<AwbSectionProps> = ({
  icon,
  title,
  action,
  children,
  sx,
  'data-testid': testId,
}) => (
  <SectionCard sx={sx} data-testid={testId}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap="1rem">
      <Stack direction="row" alignItems="center" gap="0.5rem">
        {icon && (
          <Box display="flex" sx={{ color: (theme) => theme.palette.blue[500] }}>
            {icon}
          </Box>
        )}
        <DetailsCardTitle>{title}</DetailsCardTitle>
      </Stack>
      {action}
    </Stack>
    {children}
  </SectionCard>
);

export default AwbSection;
